import { useTranslation } from "react-i18next"

import type { Audience } from "@/api/plugins-api"

import { DirectorySearch } from "@/components/directory-search"
import { X } from "@/components/icons"
import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"

export function PluginAudiencePicker({
  value,
  onChange,
}: {
  value: Audience
  onChange: (value: Audience) => void
}) {
  const { t } = useTranslation()
  return (
    <div className="space-y-3 rounded-lg border p-3">
      <label className="flex items-center gap-2 text-sm">
        <Checkbox
          checked={value.everyone}
          onCheckedChange={(checked) => onChange({ ...value, everyone: checked === true })}
        />
        {t("plugins.everyone")}
      </label>
      {!value.everyone && (
        <>
          <DirectorySearch
            onSelect={(result) => {
              const field = result.type === "group" ? "groups" : "users"
              onChange({
                ...value,
                [field]: [...new Set([...value[field], result.oid])],
                labels: { ...value.labels, [result.oid]: result.displayName },
              })
            }}
          />
          <ul className="space-y-1">
            {[...value.users, ...value.groups].map((oid) => (
              <li key={oid} className="flex items-center justify-between gap-2 text-sm">
                <span className="truncate">{value.labels?.[oid] ?? oid}</span>
                <Button
                  aria-label={t("plugins.removePerson")}
                  size="icon"
                  variant="ghost"
                  onClick={() =>
                    onChange({
                      ...value,
                      users: value.users.filter((item) => item !== oid),
                      groups: value.groups.filter((item) => item !== oid),
                    })
                  }
                >
                  <X className="size-4" />
                </Button>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  )
}
